import { useEffect, useState } from "react";
import ContainerSimple from "../../../Components/ContainerSimple";
import InputAdmin from "../../../Components/InputFields/InputAdmin";
import Custom from "../../../Components/Buttons/Custom";
import { API_BASE_URL } from "../../../config/api";
import { authFetch, responseError } from "../../../api/authFetch";
import LeverageValueList from "./LeverageValueList";
import Spinner from "../../../Components/AsyncState/Spinner";

export default function LeverageSettingsModal({ challengeId, onClose, onSaved }) {
  const [mode, setMode] = useState("fixed");
  const [fixedLeverage, setFixedLeverage] = useState("");
  const [options, setOptions] = useState([]);
  const [newValue, setNewValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const endpoint = `${API_BASE_URL}/api/v0/challenges/admin/${challengeId}/leverage/`;

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const response = await authFetch(endpoint);
        if (!response || !response.ok) throw new Error("دریافت تنظیمات اهرم ناموفق بود.");
        const data = await response.json();
        if (!active) return;
        setMode(data.mode);
        setFixedLeverage(data.fixed_leverage ?? "");
        setOptions(data.options || []);
      } catch (err) {
        if (active) setError(err.message);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [endpoint]);

  const addOption = () => {
    const value = Number(newValue);
    if (!Number.isInteger(value) || value < 1) return setError("اهرم باید عدد صحیح بزرگ‌تر از صفر باشد.");
    if (options.includes(value)) return setError("این اهرم قبلاً اضافه شده است.");
    setOptions([...options, value]);
    setNewValue("");
    setError("");
  };
  const moveOption = (index, direction) => {
    const next = [...options];
    [next[index], next[index + direction]] = [next[index + direction], next[index]];
    setOptions(next);
  };
  const save = async () => {
    const fixed = Number(fixedLeverage);
    if (mode === "fixed" && (!Number.isInteger(fixed) || fixed < 1)) return setError("اهرم ثابت معتبر وارد کنید.");
    if (mode === "selectable" && options.length === 0) return setError("حداقل یک اهرم مجاز اضافه کنید.");
    setSaving(true); setError("");
    try {
      const response = await authFetch(endpoint, {
        method: "PUT",
        body: JSON.stringify({ mode, fixed_leverage: mode === "fixed" ? fixed : null, options: mode === "selectable" ? options : [] }),
      });
      if (!response) return;
      if (!response.ok) throw new Error(await responseError(response, "ذخیره تنظیمات اهرم ناموفق بود."));
      const data = await response.json();
      onSaved(data);
      onClose();
    } catch (err) { setError(err.message); } finally { setSaving(false); }
  };

  return (
    <ContainerSimple>
      <div className="flex items-center justify-between"><h2 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">ویرایش تنظیمات اهرم</h2><button type="button" onClick={onClose} aria-label="بستن" className="text-2xl text-zi-text-light dark:text-zi-text-dark">×</button></div>
      {loading ? <div role="status" aria-label="در حال دریافت تنظیمات اهرم" className="flex min-h-40 items-center justify-center text-[#8080804d]"><Spinner /></div> : <>
        <div className="grid grid-cols-2 gap-2 rounded-xl bg-zi-bg1-light dark:bg-zi-bg1-dark p-1">
          {[{value:"fixed",label:"اهرم ثابت"},{value:"selectable",label:"انتخاب توسط معامله‌گر"}].map((item) => <button type="button" key={item.value} onClick={() => setMode(item.value)} className={`rounded-lg p-2 text-sm ${mode === item.value ? "bg-zi-blue-light text-white" : "text-zi-text-light dark:text-zi-text-dark"}`}>{item.label}</button>)}
        </div>
        {mode === "fixed" ? <InputAdmin label="اهرم ثابت" id="fixedLeverage" type="number" value={fixedLeverage} onChange={(e) => setFixedLeverage(e.target.value)} isLtr /> : <div className="flex flex-col gap-3"><div className="flex items-end gap-2"><InputAdmin label="افزودن اهرم مجاز" id="newLeverage" type="number" value={newValue} onChange={(e) => setNewValue(e.target.value)} isLtr /><Custom text="افزودن" onClick={addOption} className="shrink-0 !rounded-lg !px-5 bg-zi-gradient-button-blue text-white" /></div><LeverageValueList values={options} onMove={moveOption} onRemove={(index) => setOptions(options.filter((_, i) => i !== index))} /></div>}
        <p className="rounded-lg bg-amber-500/10 p-3 text-xs text-amber-700 dark:text-amber-300">این تغییر فقط روی حساب‌هایی که پس از ذخیره ساخته می‌شوند اعمال می‌شود و حساب‌های فعال فعلی تغییر نمی‌کنند.</p>
        {error && <p role="alert" className="text-sm text-red-500">{error}</p>}
        <div className="flex gap-3"><Custom text="انصراف" onClick={onClose} className="w-full !rounded-lg border border-zi-border-light dark:border-zi-border-dark text-zi-text-light dark:text-zi-text-dark" /><Custom text="ذخیره تنظیمات" onClick={save} loading={saving} disabled={loading} className="w-full !rounded-lg bg-zi-gradient-button-blue text-white" /></div>
      </>}
    </ContainerSimple>
  );
}
